import { TargetType } from "~/gql/graphqlBase.generated";

// wsapi is migrating a CATEGORY level's targetId from the category code to a guid, carrying the current code in targetName during the migration window.
export const levelHasTargetId = (
	level: { targetId: string; targetName?: string | null; type: TargetType },
	targetId: string
): boolean =>
	level.targetId === targetId ||
	(level.type === TargetType.Category && !!level.targetName && level.targetName === targetId);

export const categoryLevelCode = (level: { targetId: string; targetName?: string | null; type: TargetType }): string =>
	level.type === TargetType.Category && level.targetName ? level.targetName : level.targetId;
